import * as React from "react";
import { ITag, Label } from "@fluentui/react";
import { IListLookup } from "../../../../../interfaces/advancedSearch/IListLookup";
import { LanguageContext } from "../../../../../../../utilities/LocalizationModule";
import { ListItemPicker } from "../../../../inputs/listItemPicker/ListItemPicker";

const ListLookupPicker: React.FunctionComponent<IListLookup> = props => {
    const languageStrings = React.useContext(LanguageContext);

    const handleOnChange = (items: ITag[]) => {
        props.handleValueChange(props.searchInputData?.index, items.map(item => item.name));
    };

    return (
        <div style={{ width: "100%" }}>
            <Label>{props.displayName}</Label>
            <ListItemPicker
                listId={props.listId}
                columnInternalName={props.columnInternalName}
                webUrl={props.webUrl}
                itemLimit={props.itemLimit}
                suggestionsHeaderText={languageStrings.SuggestedValues}
                onSelectedItem={handleOnChange}
                substringSearch={true}
            />
        </div>
    );
};

export default ListLookupPicker;